import React from "react";
import {useFormikContext} from "formik";
import LineComponent from "../../../../../common/ui/Line";

export default function CyberAssuranceProtection2({translation, printRef}) {
    const formikProps = useFormikContext();

    return (
        <div ref={printRef}>
            <div className={'item'}>
                <h5>{translation("step2Label")}</h5>
            </div>

            <div className={'item'}>
                <h6>{translation('policeNumberLabel')}</h6>
                <p>{formikProps.values['assistaPoliceNumber']}</p>
            </div>

            <div className={'item'}>
                <h6>{translation('companyNameLabel')}</h6>
                <p>{formikProps.values['assistaCompanyName']}</p>
            </div>

            <div className={'item-names'}>
                <div>
                    <h6>{translation('firstnameLabel')}</h6>
                    <p>{formikProps.values['assistaFirstname']}</p>
                </div>
                <div>
                    <h6>{translation('surnameLabel')}</h6>
                    <p>{formikProps.values['assistaSurname']}</p>
                </div>
            </div>

            <div className={'item'}>
                <h6>{translation('birthdayLabel')}</h6>
                <p>{formikProps.values['assistaBirthday']}</p>
            </div>

            <div className={'item'}>
                <div>
                    <h6>{translation('addressLabel')}</h6>
                    <p>{formikProps.values['assistaAddress']}</p>
                </div>
            </div>

            <div className={'item-street'}>
                <div>
                    <h6>{translation('npaLabel')}</h6>
                    <p>{formikProps.values['assistaAddressNPA']}</p>
                </div>
                <div>
                    <h6>{translation('cityLabel')}</h6>
                    <p>{formikProps.values['assistaAddressCity']}</p>
                </div>
            </div>

            <div className={'item'}>
                <h6>{translation('landLabel')}</h6>
                <p>{formikProps.values['assistaLand']}</p>
            </div>

            <div className={'item'}>
                <h6>{translation('phoneNumberLabel')}</h6>
                <p>{formikProps.values['assistaPhone']}</p>
            </div>

            <div className={'item'}>
                <h6>{translation('phoneNumberBisLabel')}</h6>
                <p>{formikProps.values['assistaPhoneBis']}</p>
            </div>

            <div className={'item'}>
                <h6>{translation('emailLabel')}</h6>
                <p>{formikProps.values['assistaEmail']}</p>
            </div>

            <div className={'item'}>
                <h6>{translation('holderInformationLabel')}</h6>
            </div>

            <div className={'item-names'}>
                <div>
                    <h6>{translation('firstnameLabel')}</h6>
                    <p>{formikProps.values['assistaHolderFirstname']}</p>
                </div>
                <div>
                    <h6>{translation('surnameLabel')}</h6>
                    <p>{formikProps.values['assistaHolderSurname']}</p>
                </div>
            </div>

            <div className={'item'}>
                <h6>{translation('holderLabel')}</h6>
                <p>{formikProps.values['assistaHolderCompany']}</p>
            </div>

            <LineComponent/>
        </div>
    )
}